import { Route } from '@angular/router';
import { FULL_ACCESS_ROLES } from '@app/core/services/http/auth/auth.service';

export const productParametersRoutes: Route = {
  path: 'product-parameters',
  data: { roles: [...FULL_ACCESS_ROLES] },
  children: [
    { path: '', pathMatch: 'full', redirectTo: 'categories' },
    {
      path: 'categories',
      loadComponent: () =>
        import('./categories/categories.component').then(m => m.CategoriesComponent),
    },
    {
      path: 'category-access',
      loadComponent: () =>
        import('./category-access/category-access.component').then(m => m.CategoryAccessComponent),
    },
    {
      path: 'subcategories',
      loadComponent: () =>
        import('./subcategories/subcategories.component').then(m => m.SubcategoriesComponent),
    },
    {
      path: 'subcategory-dictionaries',
      loadComponent: () =>
        import('./subcategory-dictionaries/subcategory-dictionaries.component').then(
          m => m.SubcategoryDictionariesComponent
        ),
    },
    {
      path: 'damages-packages',
      loadComponent: () =>
        import('./damages-packages/damages-packages.component').then(
          m => m.DamagesPackagesComponent
        ),
      children: [
        { path: '', pathMatch: 'full', redirectTo: 'damage-types' },
        {
          path: 'damage-types',
          loadComponent: () =>
            import('./damages-packages/damage-types/damage-types.component').then(
              m => m.DamageTypesComponent
            ),
        },
        {
          path: 'packages-management',
          loadComponent: () =>
            import('./damages-packages/packages-management/packages-management.component').then(
              m => m.PackagesManagementComponent
            ),
        },
        {
          path: 'packages-management/:packageId',
          loadComponent: () =>
            import(
              './damages-packages/packages-management/package-details/package-details.component'
            ).then(m => m.PackageDetailsComponent),
        },
      ],
    },
    {
      path: 'plans',
      loadComponent: () => import('./plans/plans.component').then(m => m.PlansComponent),
    },
  ],
};
